import _React from 'react'
import _styled from 'styled-components'

export const React = _React
export const styled = _styled
